import { Establishment } from './establishment.model';

export interface Category {
  title: string;
  places: Establishment[];
}
